import { AnalyticEventValue } from '../../../../../shared/entity_datas/EntityDatas.ts';
import { showBecomeMemberDialog } from '../../../../shared/scripts/ui_popup/showBecomeMemberDialog.ts';
export function registerDiscordRoomClientHandlers(roomClient) {
    roomClient.onFailedToStartGameMembershipRequired(()=>{
        showBecomeMemberDialog('gameplay', AnalyticEventValue.PopupMembershipIncentiveDiscordGeneral);
    }, true);
}
